import React, { Fragment, useEffect, useState } from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBuilding,
    faList,
    faBarcode,
    faPrint,
} from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../../Utiles/BotonBack'
import Subtitulo from '../../Utiles/Subtitulo'
import Header from '../../Header/Header'
import ModalArticuloEtiquetas from '../ModalArticuloEtiquetas/ModalArticuloEtiquetas'
import ItemEtiqueta from './ItemEtiqueta'

// router
import { withRouter } from 'react-router-dom'

// services
import { getAllSucursales } from '../../../Services/sucursalService'
import { getAllListasPrecios } from '../../../Services/listaPrecioService'
import { postCodigoBarra } from '../../../Services/reporteService'

// alerts
import Swal from 'sweetalert2'

const GenerarEtiquetas = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [sucursales, setSucursales] = useState([])
    const [sucursal, setSucursal] = useState(token.sucursal || null)
    const [listaPrecios, setListaPrecios] = useState([])
    const [listaPrecio, setListaPrecio] = useState({
        id: null,
        nombre: 'SIN LISTA',
    })
    const [articulosEtiqueta, setArticulosEtiqueta] = useState([])
    const [generando, setGenerando] = useState(false)

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        getAllSucursales(true, 0, '', 1000)
            .then((res) => setSucursales(res.data.content))
            .catch((err) => console.log('error get sucursal'))
        getAllListasPrecios(true, 0, '', 1000)
            .then((res) =>
                setListaPrecios([
                    { id: null, nombre: 'SIN LISTA' },
                    ...res.data.content,
                ])
            )
            .catch((err) => console.log('error get listas precios'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAddArticulo = (item) => {
        // Evitar duplicados
        const yaAgregado = articulosEtiqueta.some(
            (a) => a.articuloId === item.articuloId
        )
        if (yaAgregado) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'El artículo ya está en la lista',
                type: 'info',
                showConfirmButton: false,
                timer: 1500,
            })
            return
        }

        setArticulosEtiqueta((prev) => [...prev, item])
    }

    const handleRemoveArticulo = (item) => {
        setArticulosEtiqueta((prev) =>
            prev.filter((a) => a.articuloId !== item.articuloId)
        )
    }

    const handleGenerarEtiquetas = async () => {
        if (articulosEtiqueta.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Lista vacía',
                text: 'Agregue al menos un artículo para generar etiquetas.',
                showConfirmButton: true,
            })
            return
        }

        const resource = articulosEtiqueta.map((a) => ({
            nombre: a.nombre,
            codigoBarra: a.codigoBarra,
            precio: a.precio,
        }))

        setGenerando(true)
        try {
            Swal.fire({
                title: 'Generando etiquetas...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            })

            const res = await postCodigoBarra(resource)
            Swal.close()

            const contenido = encodeURI(res.data)
            const win = window.open('')
            win.document.write(
                `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/pdf;base64,${contenido}'></iframe>`
            )
        } catch (error) {
            Swal.close()
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text:
                    error.response?.data?.message ||
                    'Hubo un problema al generar las etiquetas.',
                showConfirmButton: true,
            })
        } finally {
            setGenerando(false)
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBarcode} title={'Generar Etiquetas'} />
                </div>

                <div className="bg-gris p-4">
                    {/* Selectores Sucursal y Lista */}
                    <div className="d-flex flex-wrap mb-4 align-items-center">
                        {rol === 'ROLE_ADMIN' && (
                            <>
                                <div className="dropdown mr-3 mb-2">
                                    <button
                                        className="btn btn-outline-info btn-lg dropdown-toggle"
                                        type="button"
                                        id="dropdownSucursalEtiquetas"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <FontAwesomeIcon icon={faBuilding} />{' '}
                                        {sucursal?.nombre || 'Sucursal'}
                                    </button>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownSucursalEtiquetas"
                                    >
                                        {sucursales.map((s) => (
                                            <button
                                                key={s.id}
                                                className="dropdown-item"
                                                onClick={() =>
                                                    setSucursal(s)
                                                }
                                            >
                                                {s.nombre}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="dropdown mr-3 mb-2">
                                    <button
                                        className="btn btn-outline-danger btn-lg dropdown-toggle"
                                        type="button"
                                        id="dropdownListaEtiquetas"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <FontAwesomeIcon icon={faList} />{' '}
                                        {listaPrecio?.nombre || 'Lista'}
                                    </button>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownListaEtiquetas"
                                    >
                                        {listaPrecios.map((lista) => (
                                            <button
                                                key={lista.id ?? 'sin-lista'}
                                                className="dropdown-item"
                                                onClick={() =>
                                                    setListaPrecio(lista)
                                                }
                                            >
                                                {lista.nombre}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="mr-3 mb-2">
                            <ModalArticuloEtiquetas
                                sucursal={sucursal}
                                listaPrecio={listaPrecio}
                                onAddArticulo={handleAddArticulo}
                            />
                        </div>
                        <button
                            type="button"
                            className="btn btn-outline-success btn-lg mb-2"
                            onClick={handleGenerarEtiquetas}
                            disabled={
                                articulosEtiqueta.length === 0 || generando
                            }
                        >
                            <FontAwesomeIcon icon={faPrint} /> Generar etiquetas
                        </button>
                    </div>

                    {/* Tabla de artículos seleccionados */}
                    <div className="mt-4">
                        <h6 className="mb-3">
                            Artículos a imprimir ({articulosEtiqueta.length})
                        </h6>
                        <table className="table table-striped text-center">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">Código</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Código de Barra</th>
                                    <th scope="col">Precio</th>
                                    <th scope="col">Quitar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {articulosEtiqueta.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            className="text-muted py-4"
                                        >
                                            Use el botón "Agregar artículo" para
                                            buscar y añadir artículos a la lista.
                                        </td>
                                    </tr>
                                ) : (
                                    articulosEtiqueta.map((item) => (
                                        <ItemEtiqueta
                                            key={item.articuloId}
                                            item={item}
                                            onRemove={handleRemoveArticulo}
                                        />
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(GenerarEtiquetas)
